import type { RouteRecordRaw } from 'vue-router';

export const tableRoute: RouteRecordRaw = {
  path: '/verbs/table',
  name: 'VerbsTable',
  component: () => import('./pages/VerbsTablePage.vue'),
  meta: { layout: 'main' },
};

export const analyzerRoute: RouteRecordRaw = {
  path: '/verbs/analyzer',
  name: 'VerbsAnalyzer',
  component: () => import('./pages/VerbsAnalyzerPage.vue'),
  meta: { layout: 'main' },
};

export const irregularRoute: RouteRecordRaw = {
  path: '/verbs/irregular',
  name: 'VerbsIrregular',
  component: () => import('./pages/VerbsIrregularPage.vue'),
  meta: { layout: 'main' },
};

export const trainerRoute: RouteRecordRaw = {
  path: '/verbs/trainer',
  name: 'VerbsTrainer',
  component: () => import('./pages/VerbsTrainerPage.vue'),
  meta: { layout: 'main' },
};

export const pastRoute: RouteRecordRaw = {
  path: '/verbs/past',
  name: 'VerbsPast',
  component: () => import('./pages/VerbsPastPage.vue'),
  meta: { layout: 'main' },
};

export const futureTheoryRoute: RouteRecordRaw = {
  path: '/verbs/future/theory',
  name: 'VerbsFutureTheory',
  component: () => import('./pages/VerbsFutureTheoryPage.vue'),
  meta: { layout: 'main' },
};

export const futureTableRoute: RouteRecordRaw = {
  path: '/verbs/future/table',
  name: 'VerbsFutureTable',
  component: () => import('./pages/VerbsFutureTablePage.vue'),
  meta: { layout: 'main' },
};

export const futureTrainerRoute: RouteRecordRaw = {
  path: '/verbs/future/trainer',
  name: 'VerbsFutureTrainer',
  component: () => import('./pages/VerbsFutureTrainerPage.vue'),
  meta: { layout: 'main' },
};

export const futureIrregularTheoryRoute: RouteRecordRaw = {
  path: '/verbs/future/irregular/theory',
  name: 'VerbsFutureIrregularTheory',
  component: () => import('./pages/VerbsFutureIrregularTheoryPage.vue'),
  meta: { layout: 'main' },
};

export const futureIrregularTableRoute: RouteRecordRaw = {
  path: '/verbs/future/irregular/table',
  name: 'VerbsFutureIrregularTable',
  component: () => import('./pages/VerbsFutureIrregularTablePage.vue'),
  meta: { layout: 'main' },
};

export const futureIrregularTrainerRoute: RouteRecordRaw = {
  path: '/verbs/future/irregular/trainer',
  name: 'VerbsFutureIrregularTrainer',
  component: () => import('./pages/VerbsFutureIrregularTrainerPage.vue'),
  meta: { layout: 'main' },
};
